(function () {
  const initSlider = (section) => {
    if (!section) return;

    const swiperEl = section.querySelector(".bw-hartan-timeline__swiper");
    if (!swiperEl) return;

    if (swiperEl.swiper) {
      swiperEl.swiper.destroy();
    }

    const scrollbar = section.querySelector(".bw-hartan-timeline__bar");

    new Swiper(swiperEl, {
      slidesPerView: "auto",
      spaceBetween: 0,
      speed: 800,
      allowTouchMove: true,
      grabCursor: true,
      watchSlidesProgress: true,
      mousewheel: {
        forceToAxis: true,
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      scrollbar: scrollbar
        ? {
            el: scrollbar,
            draggable: true,
          }
        : undefined,
    });
  };

  const animateSection = (section) => {
    if (!section) return;

    const items = section.querySelectorAll(
      ".bw-hartan-timeline__content.animate-on-scroll"
    );
    if (!items.length) return;

    const reveal = () =>
      items.forEach((item) => item.classList.add("animated"));

    if (typeof ScrollTrigger === "undefined") {
      reveal();
      return;
    }

    ScrollTrigger.create({
      trigger: section.querySelector(".bw-hartan-timeline__swiper"),
      start: "50% 90%",
      end: "bottom top",
      onEnter: reveal,
    });
  };

  const sectionEl = document.currentScript?.parentElement;

  const init = (section) => {
    initSlider(section);
    animateSection(section);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init(sectionEl));
  } else {
    init(sectionEl);
  }

  document.addEventListener("shopify:section:load", (event) => {
    if (event.target.querySelector(".bw-hartan-timeline__swiper")) {
      init(event.target);
    }
  });
})();
